/** @format */

import { Link } from 'gatsby-plugin-intl';
import styled from 'styled-components';

export const WorkingHours = styled.span`
  display: block;
  width: 100%;

  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.joivy['teal-dark']};
  text-align: center;

  padding: 0.25rem 1.25rem;
`;

export const ContactBookingContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  width: 100%;

  h4 {
    color: ${({ theme }) => theme.colors.joivy['teal-dark']};
    font-size: 20px;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.lg}) {
    align-items: flex-start;
  }
`;

export const StyledLink = styled(Link)`
  outline: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.75rem;

  --bg-color: transparent;
  --border-color: ${({ theme }) => theme.colors.joivy['teal-dark']};
  --text-color: ${({ theme }) => theme.colors.joivy['teal-dark']};
  --img-filter: invert(26%) sepia(11%) saturate(5979%) hue-rotate(149deg) brightness(96%) contrast(99%);

  text-decoration: none;

  padding: 0.75rem 1.25rem;
  color: var(--text-color);
  background-color: var(--bg-color);
  border: 1px solid var(--border-color);
  border-radius: 2.25rem;
  text-decoration: none;
  font-size: clamp(1rem, 0.9583rem + 0.1852vw, 1.125rem);
  font-weight: 600;
  line-height: clamp(1.375rem, 1.3333rem + 0.1852vw, 1.5rem);
  letter-spacing: clamp(0.03rem, 0.0287rem + 0.0056vw, 0.03375rem);
  cursor: pointer;

  transition: all 0.5s cubic-bezier(0.36, 0.33, 0, 1) 0s;

  img {
    filter: var(--img-filter);
    transition: all 0.5s cubic-bezier(0.36, 0.33, 0, 1) 0s;
  }

  &:hover {
    --border-color: ${({ theme }) => theme.colors.joivy['teal-light']};
    --text-color: ${({ theme }) => theme.colors.joivy['teal-light']};
    --img-filter: invert(57%) sepia(45%) saturate(601%) hue-rotate(135deg) brightness(96%) contrast(83%);
  }
`;

export const H4 = styled.h4`
  margin-block: 15px;
  font-size: 24px;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.joivy.black};
`;

export const ContainerButtons = styled.div<{ $mobile?: boolean }>`
  display: grid;
  gap: 0.75rem;

  ${({ $mobile }) =>
    $mobile &&
    `
    margin-bottom: 1rem;
  `}
`;
